/**
* In this file use to trigger the Analytics post API service
**/
import ApiService from './ApiService';
import {analyticsRequest} from './UtilsService';

	/**
	* This function is used to create Analytics
	* date pass parent,member and module keywords in Object format
	   parent pass the parent id
	   member pass the member id 
	   module pass the module name
	**/
	const postAnalytics =async(data)=>{
		var reqData=analyticsRequest();
		reqData.parent = data.parent;
		reqData.member = data.member;
		reqData.module = data.module;
		reqData.type = data.type?data.type:'dashboard';
		reqData.screenStartTime = sessionStorage.getItem('screenStartTime');
		reqData.screenEndTime = new Date().toString();
		await ApiService.createAnalytics({analyticsData:[reqData]});
		sessionStorage.clear();
	}

export { postAnalytics };